import { successfulSubmitComponent } from './successfulSubmit.component';
import { receivingStateName } from '../../../tickets.state';
import { TicketService } from '../../../../ticket/ticket.service';

export const successfulSubmitStateName = `${receivingStateName}.successfulSubmit`;

export const successfulSubmitState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: successfulSubmitStateName,
    url: '/request/success/:ticketId',
    component: successfulSubmitComponent.name,
    data: { requiresAuth: true },
    resolve: {
      ticket: TicketService.ticket(),
      stateIndex: () => 3
    }
  });
};
